import { render, staticRenderFns } from "./allGradesComparison_new.vue?vue&type=template&id=5c186a71&scoped=true&"
import script from "./allGradesComparison_new.vue?vue&type=script&lang=js&"
export * from "./allGradesComparison_new.vue?vue&type=script&lang=js&"
import style0 from "./allGradesComparison_new.vue?vue&type=style&index=0&id=5c186a71&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c186a71",
  null
  
)

export default component.exports